import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
// import { NavBar } from "./components/NavBar";
// import { Banner } from "./components/Banner";
// import { Skills } from "./components/Skills";
// import { Projects } from "./components/Projects";
// import { Testimonial } from './components/Testimonial';
// import { Contact } from "./components/Contact";
// import { Footer } from "./components/Footer";
// import Experience from './components/Experience';
import Preloader from './components/Preloader';

function App() {


  
  return (
    <div className="App">
    
          <Preloader/> 
          {/* <NavBar />
          <Banner />
          <Skills />
          <Experience/>
          <Projects />
          <Testimonial/>
          <Contact />
          <Footer />  */}

    </div>
  );
}

export default App;
